import { Component, OnInit , ViewChild, Input, ElementRef} from '@angular/core';

 declare var google;

@Component({
  selector: 'moment-card',
  templateUrl: './moment-card.component.html',
  styleUrls: ['./moment-card.component.scss']
})
export class MomentCardComponent implements OnInit {
  @ViewChild('content') public contentModal;
  @ViewChild('map') mapElement: ElementRef;
  @Input() moment: any;

  currentMoment: { [index: string]: any} = {};
  map: any;

  constructor() { }

  ngOnInit() {
  }

  initMap() {
    let startIndex = this.moment.coords.indexOf(",");
    let startLat = Number(this.moment.coords.substring(0, startIndex));
    let startLong = Number(this.moment.coords.substring(startIndex + 1));
        var uluru = {lat: startLat, lng: startLong};
        this.map = new google.maps.Map(this.mapElement.nativeElement, {
          zoom: 8,
          center: uluru
        });
        console.log(uluru)
        // var map = new google.maps.Map(document.getElementById('map'), {
        //   zoom: 4,
        //   center: uluru
        // });
        var marker = new google.maps.Marker({
          position: uluru,
          map: this.map,
          animation: google.maps.Animation.DROP
        });
      }

  viewMoment(moment) {
    console.log('view')
    console.log(moment)
    this.currentMoment = moment;
    this.initMap();

    // var uluru = {lat: -25.363, lng: 131.044};
    //     var map = new google.maps.Map(document.getElementById('map'), {
    //       zoom: 4,
    //       center: uluru
    //     });
    //     var marker = new google.maps.Marker({
    //       position: uluru,
    //       map: map
    //     });


    this.contentModal.show();
  }

}



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/moment-card/moment-card.component.ts